import { useState } from 'react';
import { IRAQ_MAP, IRAQ_MAP_VIEWBOX } from '../../data/iraqMap';

// Choropleth of Iraq: each governorate is shaded by revenue or order count,
// with a ranked list beside it. Hovering either highlights the other.
const IraqMapChart = ({ data, isRtl, formatCurrency }) => {
  const [metric, setMetric] = useState('revenue');
  const [hovered, setHovered] = useState(null);

  const byCity = {};
  data.forEach((g) => { byCity[g.city] = g; });

  const value = (g) => (g ? (metric === 'revenue' ? g.revenue : g.orderCount) : 0);
  const max = Math.max(...data.map(value), 1);
  const ranked = [...data].sort((a, b) => value(b) - value(a));
  const shown = hovered ? byCity[hovered] : null;
  const name = (g) => (isRtl ? g.cityAr : g.city);
  const fmt = (g) => (metric === 'revenue' ? formatCurrency(g.revenue) : g.orderCount);

  const opacityFor = (g) => (g ? 0.15 + 0.85 * (value(g) / max) : 0.04);

  return (
    <div className="iraq-map">
      <div className="iraq-map-svg-wrap">
        <div className="iraq-map-toggle">
          <button
            className={metric === 'revenue' ? 'active' : ''}
            onClick={() => setMetric('revenue')}
          >
            {isRtl ? 'الإيرادات' : 'Revenue'}
          </button>
          <button
            className={metric === 'orders' ? 'active' : ''}
            onClick={() => setMetric('orders')}
          >
            {isRtl ? 'الطلبات' : 'Orders'}
          </button>
        </div>

        <svg viewBox={IRAQ_MAP_VIEWBOX} className="iraq-map-svg" role="img">
          {Object.entries(IRAQ_MAP).map(([key, shape]) => {
            const g = byCity[key];
            return (
              <g key={key}>
                <path
                  d={shape.d}
                  fill="var(--primary)"
                  fillOpacity={opacityFor(g)}
                  stroke="#fff"
                  strokeWidth={hovered === key ? 2.5 : 1.2}
                  style={{ cursor: 'pointer', transition: 'fill-opacity .15s' }}
                  onMouseEnter={() => setHovered(key)}
                  onMouseLeave={() => setHovered(null)}
                />
                {hovered === key && (
                  <path d={shape.d} fill="none" stroke="var(--primary)" strokeWidth={2} pointerEvents="none" />
                )}
              </g>
            );
          })}
        </svg>

        <div className="iraq-map-info">
          {shown ? (
            <>
              <strong>{name(shown)}</strong>
              <span>{isRtl ? 'الطلبات' : 'Orders'}: {shown.orderCount}</span>
              <span>{isRtl ? 'الإيرادات' : 'Revenue'}: {formatCurrency(shown.revenue)}</span>
            </>
          ) : (
            <span className="iraq-map-hint">
              {isRtl ? 'مرّر على محافظة لعرض التفاصيل' : 'Hover a governorate for details'}
            </span>
          )}
        </div>
      </div>

      <ol className="iraq-map-list">
        {ranked.map((g, i) => (
          <li
            key={g.city}
            className={hovered === g.city ? 'hover' : ''}
            onMouseEnter={() => setHovered(g.city)}
            onMouseLeave={() => setHovered(null)}
          >
            <span className="rank">{i + 1}</span>
            <span className="name">{name(g)}</span>
            <span className="val">{fmt(g)}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default IraqMapChart;
